import React from 'react';
import { Box, Button, ButtonGroup, Heading, Modal, Paragraph, TextButton } from '@zillow/constellation-10';
import {
  CREDIT_TRACKING_OPT_OUT_WARNING_MESSAGE,
  PAYMENT_REPORTING_OPT_OUT_WARNING_MESSAGE,
} from '@renter-hub/constants/notificationMessages';

export type OptOutType = 'credit-tracking' | 'rent-reporting';

interface OptOutModalProps {
  open: boolean;
  onClose: () => void;
  onOptOut: () => void;
  type: OptOutType;
}

export const OptOutModal: React.FC<OptOutModalProps> = ({ open, onClose, onOptOut, type }) => {
  const getTitle = () => {
    switch (type) {
      case 'credit-tracking':
        return 'Opt out of credit tracking?';
      case 'rent-reporting':
        return 'Do you want to opt out?';
      default:
        return 'Opt out?';
    }
  };

  const getBodyMessage = () => {
    switch (type) {
      case 'credit-tracking':
        return CREDIT_TRACKING_OPT_OUT_WARNING_MESSAGE;
      case 'rent-reporting':
        return PAYMENT_REPORTING_OPT_OUT_WARNING_MESSAGE;
      default:
        return '';
    }
  };

  const getConfirmButtonText = () => {
    switch (type) {
      case 'credit-tracking':
        return 'Yes, opt out';
      case 'rent-reporting':
        return 'Opt out';
      default:
        return 'Opt out';
    }
  };

  return (
    <Modal
      size={type === 'rent-reporting' ? 'md' : undefined}
      open={open}
      trigger={null}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          onClose();
        }
      }}
      header={
        <Box css={{ padding: '16px 48px 16px 16px !important' }}>
          <Heading level={2} textStyle="heading-xs">
            {getTitle()}
          </Heading>
        </Box>
      }
      footer={
        <Box css={{ padding: 'token(spacing.sm) !important' }}>
          <ButtonGroup aria-label="Opt out actions">
            <TextButton onClick={onClose}>Cancel</TextButton>
            <Button emphasis="filled" tone={type === 'credit-tracking' ? 'brand' : undefined} onClick={onOptOut}>
              {getConfirmButtonText()}
            </Button>
          </ButtonGroup>
        </Box>
      }
      body={
        <Box css={{ padding: 'token(spacing.sm) !important' }}>
          <Paragraph>{getBodyMessage()}</Paragraph>
        </Box>
      }
    />
  );
};
